


import React from 'react';
import { Table,Box,useTheme, TableContainer, TableHead, TableRow, TableCell, TableBody } from "@mui/material";

import { tokens } from '../../theme/theme';


const ViewTableData = ({ columns, rows }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <Box
            gridColumn="span 9"
            gridRow="span 2"
            alignItems="center"
            justifyContent="center"
            padding={1}
            sx={{
                "& .MuiTable-root": {
                    border: "none",
                    size: "small",
                },
                "& .MuiTableCell-root": {
                    borderBottom: "none",
                    border: "1px solid",
                    borderColor: `${colors.primary[400]} !important`,
                    padding: "2px",  // Further reduced padding
                },
                "& .MuiTableHead-root": {
                    borderBottom: "none",
                },
                "& .MuiTableBody-root": {
                    overflowY: "auto",
                },
                "& .MuiCheckbox-root": {
                    color: `${colors.blueAccent[200]} !important`,
                    size: "small",
                },
                "& .MuiTableFooter-root": {
                    borderTop: "none",
                    backgroundColor: colors.blueAccent[700],
                    height: "10px",
                },
                "& .MuiButton-text": {
                    color: `${colors.grey[100]} !important`,
                },
            }}
        >
            <TableContainer >
                <Table size='small'>
                    <TableHead >
                        <TableRow>
                            {columns.map((column, index) => (
                                <TableCell key={index} style={{ border: '1px solid black', fontSize: "14px",textAlign:'center' }}>{column}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ fontSize: '8px' }}>
                        {rows.map((row, rowIndex) => (
                            <TableRow key={row.id} style={{ border: '1px solid black' }}>
                                {Object.values(row).map((cell, cellIndex) => (
                                    <TableCell key={cellIndex} align="center" style={{ border: '1px solid black', fontSize: '14px', padding: 0 }}>{cell}</TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default ViewTableData;


